/* @flow */

import * as types from 'src/shared/app/faq/action/faqActionTypes';
import { createReducer } from 'src/shared/core/util/reducerUtils';

const initialState = {
  isFetching: false,
  questions: [],
};

const _fetchRequest = (state: Object) => ({
  ...state,
  isFetching: true,
});

const _fetchFailure = (state: Object) => ({
  ...state,
  isFetching: false,
});

const _setQuestions = (state: Object, action: Object) => {
  const { questionsData } = action;

  return {
    ...state,
    isFetching: false,
    questions: questionsData,
  };
};

export default createReducer(initialState, {
  [types.FETCH_SUPPORT_QUESTIONS_REQUEST]: _fetchRequest,
  [types.FETCH_SUPPORT_QUESTIONS_FAILURE]: _fetchFailure,
  [types.FETCH_SUPPORT_QUESTIONS_SUCCESS]: _setQuestions,
  [types.SIMULATE_SUPPORT_QUESTION_FETCH]: _fetchRequest,
});
